﻿export class Loan {
  REQUEST_ID: number;
  PEOPLE_ID: number;
  REQUEST_PRINCIPAL: number;
  REQUEST_TENOR: number;
  REQUEST_CURRENCY_ID: number;
  REQUEST_PERIOD_ID: number;
  REQUEST_RATE: number;
  REQUEST_RATE_PERIOD_ID: number;
  PERCENTAGE_FUNDED: number;
  LOAN_STATUS: number;
  IS_PEER_TO_PEER: number;
  TOTAL_FUNDED: number;
  REQUESTED: string;
  LEGAL_NAME: string;
  CUSTOMER_TYPE: number;
  FILE_NAME: string;
  LOAN_DURATION: string;
  LENDERS: any;
}
